































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import SlideBar from './SlideBar.vue'
import ChartProgress from './ChartProgress.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import Skill from '../../models/skill'
import UserExam from '../../models/user_exam'

@Component({
  components: {
    SlideBar,
    ChartProgress
  }
})
export default class ExamSkillReport extends Vue {
  @Prop({ required: true }) skill: Skill
  @Prop({ required: true }) userExam: UserExam
  @Prop({ default: false }) mobile: boolean

  LETTER_FORMAT = LETTER_FORMAT

  get skillAverage() {
    if (this.skill.skillItems.length == 0) {
      return 0
    }

    const result = this.skill.skillItems.reduce((total, item) => total + Number(item.averageScore), 0)
    return Math.round((result * 10) / this.skill.skillItems.length) / 10
  }

  get skillScore() {
    return this.skill.getSkillScore(this.userExam)
  }
}
